import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { Container, makeStyles, Theme, Typography } from '@fluentsms/components';

import TableError from './images/TableError.svg';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: theme.spacing(12, 0),
  },
  logo: {
    width: 160,
    height: 160,
  },
  link: {
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

export type UnknownTableProps = {
  onRefresh: () => void;
};

export const UnknownTableError = ({ onRefresh }: UnknownTableProps): ReactElement | null => {
  const classes = useStyles();

  return (
    <tr>
      <td>
        <Container className={classes.container} data-testid="unknown-table-error">
          <Typography variant="h1">Oh, Snap!</Typography>
          <img src={TableError} alt="table-error" data-testid="table-error-svg" className={classes.logo} />
          <Typography variant="body1">Something went wrong on our end.</Typography>
          <Typography variant="body1">
            <Link to="#" onClick={onRefresh} className={classes.link}>
              Refresh
            </Link>
            {` or try again later.`}
          </Typography>
        </Container>
      </td>
    </tr>
  );
};
